import React, { useContext, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import "../Styles/ShareStudyLinkCss.css";
import { Icon, TextField, Checkbox } from '@fluentui/react';
import themeContext from '../../../../context/theme/ThemeContext';
import MobileInput from '../../../../components/MobileInput';
import { getEnv } from '../../../../helpers/EnvHelper';
const ShareStudyLinkBody = (props) => {
  const [t] = useTranslation();
  const { getThemeColor, getAlterColor, themeName } = useContext(themeContext);
  let isEnableWhatsApp =   (getEnv("REACT_APP_ENABLE_WHATSAPP") == "true" || getEnv("REACT_APP_ENABLE_WHATSAPP") == true) ? true : false;
  const handleCopyUrl = () =>{
        let copyText = document.getElementById('url');
        copyText.select();
        copyText.setSelectionRange(0, 99999);

        navigator.clipboard.writeText(copyText.value);
        setLinkCopied(true);
        setTimeout(() => setLinkCopied(false), 2000);
    }

    const urlRef = useRef(null);
  const passwordRef = useRef(null);
  const [linkCopied, setLinkCopied] = useState(false);
  const [passwordCopied, setPasswordCopied] = useState(false);

  // Only show password block if there is a real password (not null/"null"/empty/undefined)
  const hasPassword = useMemo(() => {
    const p = props?.values?.studyShareUrlPassword;
    return p !== undefined && p !== null && p !== '' && p !== 'null';
  }, [props?.values?.studyShareUrlPassword]);

  const handleCopy = async (text, which) => {
    const ref = which === "link" ? urlRef : passwordRef;
    if (ref.current) {
      ref.current.select(); // highlight the input text
    try {
      await navigator.clipboard.writeText(text ?? '');
      if (which === 'link') {
        setLinkCopied(true);
        setPasswordCopied(false);
      } else {
        setPasswordCopied(true);
        setLinkCopied(false);
      }
      // auto-hide after a moment (optional)
      setTimeout(() => {
        setLinkCopied(false);
        setPasswordCopied(false);
      }, 2000);
    } catch (e) {
      // If clipboard API fails, you could fall back or show an error
      console.error('Clipboard error:', e);
    }
  }
  };

  const textFieldStyle = {
    fieldGroup: {
      '&.is-disabled': {
        background: 'transparent !important',
        border: '1px solid rgba(200, 198, 196, 0.3) !important',
        cursor: 'not-allowed',
      },
    },
    root: {
      width: '100%',
      borderRadius: '7px',
      '&.is-disabled': {
        backgroundColor: 'transparent !important',
        cursor: 'not-allowed',
        border: 'none !important'
      },
    },
    field: {
      backgroundColor: 'transparent !important',
      border: '1px solid rgba(200, 198, 196, 0.3) !important'
    },
  };

  const checkBoxStyle = {
    root: { paddingLeft: '5px' },
    checkbox: { borderColor: '#8A8886', width: '16px', height: '16px' },
  };

  const textFieldStyles = {
        root: {
          userSelect: 'none', // Make the text unselectable
        },
      };



  const readOnlyFieldStyles = {
    root: { userSelect: 'none' }, // discourages selecting, but we still allow programmatic copy
  };

  // Blocks right-click menu & Ctrl/Cmd+C if you want to prevent manual copying
  const handleContextMenu = (e) => e.preventDefault();
  const handleUserCopy = (e) => e.preventDefault();

  return (
    <div className="share-study-container">
                <div className='share-study-content'>
                    <div className='closeStudyContentContainer'>
                    <div className='content-2'>
                        <label style={{color: getThemeColor('primary-color')}} className='label'>{t("share-study.url")}</label>
                        <div className='url-copy-container'>
                        <div className='url-fields'>
                            <TextField
                                className="url-textArea1" 
                                id="url"
                                name="other"
                                value={props.values.studyShareUrl}
                                styles={textFieldStyles}
                                onContextMenu={handleContextMenu}
                                onCopy={handleCopy}
                                // disabled={true}
                            />
                            {linkCopied && (
                              <h3 className="copied-msg" id="copied-msg"
                              style={{
                                color: themeName === "light" ? "#0078D4" : "",
                                visibility: "visible",
                              }}
                              >{t("share-study.link-copied-successfully")}</h3>
                            )}
                        </div>
                        {/* <PrimaryButton
                            text={t("button.copy")}
                            onClick={handleCopyUrl}
                        /> */}
                        <div style={{display:'flex',alignItems:'start',marginTop:'5px',marginRight:'5px'}}>
                        <Icon iconName="copy" style={{fontSize:'20px',color:getAlterColor("#ffffffad",""),cursor:'pointer'}} onClick={handleCopyUrl}></Icon>
                        </div>
                        
                        </div>
                    </div>
                    { props.emailEnabled && (getEnv("REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY") == "true" || getEnv("REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY") == true) && <div className='content-2' style={{display:'flex'}}>
                        <div className='shareStudy-email-label' style={{marginRight:'10px'}}>
                            <Checkbox styles={checkBoxStyle} checked={props.isEmailChecked} defaultChecked={true} id="email-checkbox" onChange={props.handleEmailcheck}/>
                            <label style={{color: getThemeColor('primary-color')}} className='shareStudy-emailLabel'>{t("share-study.email")}</label>
                        </div>
                        <TextField
                          className="textArea" 
                          name="email"
                          styles={textFieldStyle}
                          placeholder={t("share-study.placeholder.email")}
                          onChange={props.isEmailChecked?props.handleChange:()=>{}}
                          disabled={!props.isEmailChecked}
                          value={props.values.email}
                          errorMessage={props.errors.email}
                        />
                    </div>}
                    {props.visibleWhatsapp && isEnableWhatsApp && (
                      <div className="content-2" style={{ display: 'flex', alignItems: 'center', marginTop: 12 }}>
                        <div className="shareStudy-whatsapp-label" style={{ marginRight: '10px' }}>
                          <Checkbox
                            label={<span style={{ color: themeName === "light"? "black":"white", fontWeight: 600, fontSize: 14 }}>{t("share-study.whatsapp")}</span>}
                            styles={checkBoxStyle}
                            checked={props.isWhatsappChecked}
                            id="whatsapp-checkbox"
                            onChange={(_, checked) => {props.setIsWhatsappChecked(!!checked);
                              // optional: clear whatsappNo when unchecking
                                if (!checked && props.setFieldValue) {
                                    props.setFieldValue('whatsappNo', '');
                                }
                              }
                            }
                          />
                          {/* <label
                            style={{ color: getThemeColor('primary-color') }} className="shareStudy-whatsappLabel">{t("share-study.whatsapp")}</label> */}
                        </div>

                        {/* <TextField
                          className="textArea"
                          name="whatsappNo"
                          styles={textFieldStyle}
                          placeholder={t("share-study.placeholder.whatsapp")}
                          onChange={props.isWhatsappChecked ? props.handleChange : () => {}}
                          disabled={!props.isWhatsappChecked}
                          value={props.values.whatsappNo || ""}
                          errorMessage={props.errors.whatsappNo}
                        /> */}
                            {/* <MobileInput
                              name="whatsappNo"
                              //label={"WhatsApp Number"}
                              value={props.values.whatsappNo || ""}
                              onBlurCustom={() =>
                                props.handleBlur && props.handleBlur({ target: { name: "whatsappNo" } })
                              }
                              onChangeCustom={(value) => {
                                
                                // Normalize to E.164-like: ensure leading '+'
                                if (value && !value.startsWith("+")) value = "+" + value;
                                props.setFieldValue && props.setFieldValue("whatsappNo", value);
                              }}
                              touched={props.touched && props.touched.whatsappNo}
                              errorMessage={props.touched && props.touched.whatsappNo ? props.errors.whatsappNo : undefined}
                              aria-disabled={!props.isWhatsappChecked}
                            /> */}
                            {props.isWhatsappChecked ? (
                          <div style={{ flex: 1 }}>
                            <MobileInput
                              name="whatsappNo"
                              //label={"WhatsApp Number"}
                              value={props.values.whatsappNo || ""}
                              onBlurCustom={() =>
                                props.handleBlur && props.handleBlur({ target: { name: "whatsappNo" } })
                              }
                              onChangeCustom={(value) => {
                                // Normalize to E.164-like: ensure leading '+'
                                if (value && !value.startsWith("+")) value = "+" + value;
                                props.setFieldValue && props.setFieldValue("whatsappNo", value);
                              }}
                              touched={props.touched && props.touched.whatsappNo}
                              errorMessage={props.touched && props.touched.whatsappNo ? props.errors.whatsappNo : undefined}
                            />
                            <div style={{ color: 'red', fontSize: '12px', paddingTop: '5px',fontWeight: '600' }}>
                                            {props.errors.whatsappNo}
                                        </div>
                          </div>
                        ) : (
                          // When unchecked, a visually similar disabled TextField keeps layout stable
                          <TextField
                            className="textArea"
                            name="whatsappNo"
                            styles={textFieldStyle}
                            placeholder={t("share-study.placeholder.whatsapp")}
                            onChange={() => {}}
                            disabled={true}
                            value={props.values.whatsappNo || ""}
                          />
                        )}
                      </div>
                    )}
                    </div>
                </div>
            </div>
  )
};

export default ShareStudyLinkBody;
